import { createFileRoute } from "@tanstack/react-router";
import { CardExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/foundations/cards")({
  component: CardExamples,
});
